import { isPublicHost } from "../services/externalServices";
import { publicLocation, referrerHost, reportablePath } from "../services/analyticsPrivacy";
const EVENTS = new Set([
  "page_view", "calculator_started", "calculation_complete", "comparison_used",
  "related_tool_click", "internal_link_click", "support_click", "ad_requested", "ad_filled",
  "ad_unfilled", "ad_timeout", "agent_tool_complete", "agent_tool_error", "helpfulness_vote",
]);
const LABELS = {
  helpful: new Set(["yes", "no"]),
  placement: new Set(["intro", "mid", "faq", "end", "article", "results", "footer", "navigation", "content"]),
  interaction: new Set(["input", "calculate", "compare", "agent"]),
  error_category: new Set(["invalid_input", "unsupported", "calculation", "unavailable"]),
  source: new Set(["internal", "search", "chatgpt", "claude", "direct", "referral"]),
};

export { reportablePath };
export const eventParameters = (params = {}) => {
  const safe = {};
  ["page_path", "destination_path"].forEach((key) => {
    if (params[key] !== undefined) safe[key] = reportablePath(params[key]);
  });
  Object.keys(LABELS).forEach((key) => {
    if (LABELS[key].has(params[key])) safe[key] = params[key];
  });
  if (typeof params.comparison === "boolean") safe.comparison = params.comparison;
  return safe;
};

/** Financial inputs and result amounts are never accepted as event parameters. */
const trackEvent = (name, params = {}) => {
  if (!EVENTS.has(name) || typeof window === "undefined") return;
  const safe = eventParameters({ page_path: window.location.pathname, ...params });
  if (!isPublicHost(window.location.hostname)) {
    window.dispatchEvent(new CustomEvent("studentcalc:measurement", { detail: { name, params: safe } }));
    return;
  }
  if (typeof window.gtag !== "function") return;
  try {
    window.gtag("event", name, { ...safe, page_location: publicLocation(window.location.hostname, safe.page_path || "/"), page_referrer: referrerHost(document.referrer) });
  } catch { /* Measurement cannot interrupt calculation. */ }
};
export const recordCalculation = ({ comparison } = {}) =>
  trackEvent("calculation_complete", { interaction: "calculate", comparison });
export default trackEvent;
